import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _typeof from "@babel/runtime/helpers/typeof";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { AI_MATE_CONTEXT } from '@atlaskit/analytics-namespaced-context';
var isSourceAndAttributes = function isSourceAndAttributes(x) {
  if (_typeof(x) !== 'object' || x === null) {
    return false;
  }
  if (!('source' in x) || !('attributes' in x) || _typeof(x.attributes) !== 'object' || x.attributes === null) {
    return false;
  }
  return true;
};

/**
 * Extracts the attributes from the relevant AIMate contexts.
 * Contexts is an array of (any) object - to determine which objects we want to extract the attributes from,
 * we add a source of 'AIMate' to the object, or check if it has the AI Mate namespace
 */
export var getAttributesFromContexts = function getAttributesFromContexts(context) {
  if (!context || !Array.isArray(context)) {
    return {};
  }
  var aiMateOnly = context.filter(function (x) {
    return isSourceAndAttributes(x) && x.source === 'AIMate' || x[AI_MATE_CONTEXT];
  });
  return aiMateOnly.reduce(function (acc, x) {
    var _x$AI_MATE_CONTEXT$at, _x$AI_MATE_CONTEXT, _x$attributes;
    return _objectSpread(_objectSpread(_objectSpread({}, acc), (_x$AI_MATE_CONTEXT$at = (_x$AI_MATE_CONTEXT = x[AI_MATE_CONTEXT]) === null || _x$AI_MATE_CONTEXT === void 0 ? void 0 : _x$AI_MATE_CONTEXT.attributes) !== null && _x$AI_MATE_CONTEXT$at !== void 0 ? _x$AI_MATE_CONTEXT$at : {}), (_x$attributes = x.attributes) !== null && _x$attributes !== void 0 ? _x$attributes : {});
  }, {});
};